import "virtual:windi.css";
import "virtual:windi-devtools"; // Will be an empty module in production
import type {
	TrailingSlash,
	PrerenderOption,
} from "@sveltejs/kit/types/private";

export const trailingSlash = "always" satisfies TrailingSlash;
export const prerender = true satisfies PrerenderOption;
